import { MantineProvider } from "@mantine/core";
import AllRoutes from "routes";
import { NotificationsProvider } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ModalsProvider } from "@mantine/modals";
import GoogleOAuthReturnHandler from "components/GoogleOAuthReturnHandler/GoogleOAuthReturnHandler";
import SpotlightSearchProvider from "components/SearchSpotlight/SpotlightSearchProvider";
import PostHogTracker from "components/PostHog/PostHogTracker";
import FloatingMicAssistant from "components/FloatingMicAssistant/FloatingMicAssistant";
import { FloatingMicAssistantProvider } from "components/FloatingMicAssistant/FloatingMicAssistantContext";
import { theme } from "theme";
import { useMemo } from "react";

const notificationContainerStyle = {
  width: "min(360px, calc(100vw - 112px))",
  maxWidth: "none",
};

function App() {
  const queryClient = useMemo(() => new QueryClient({
    defaultOptions: {
      queries: {
        suspense: false, // Disable suspense mode to prevent crashes
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  }), []);

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider
        theme={theme}
        withGlobalStyles
        withNormalizeCSS
      >
        <ModalsProvider>
          <NotificationsProvider
            position="bottom-left"
            style={notificationContainerStyle}
          >
            <SpotlightSearchProvider>
              <FloatingMicAssistantProvider>
                <PostHogTracker />
                <GoogleOAuthReturnHandler />
                {/* <div id="gaintime-app"> */}
                <AllRoutes />
                <FloatingMicAssistant />
                {/* </div> */}
              </FloatingMicAssistantProvider>
            </SpotlightSearchProvider>
          </NotificationsProvider>
        </ModalsProvider>
      </MantineProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
export default App;
